import { render } from "./AppHistoriku.vue?vue&type=template&id=62d9233e&scoped=true"
const script = {}

import "./AppHistoriku.vue?vue&type=style&index=0&id=62d9233e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d9233e"]])

export default __exports__